const $backBtn = $('.js-form-back');
const $nextBtn = $('.js-form-next');
const $progressBar = $('.js-form-progress');
const $formSections = $('.js-form-section');
const $formBack = $('.js-form-back-review.one');
const $formBack2 = $('.js-form-back-review.two');

const $formControls = $('.js-form-controls');
const maxSteps = $formSections.length;
const step5 = $('.js-form-section[data-index="5"]');
const step6 = $('.js-form-section[data-index="6"]');
const $elementsToHideUntilStep7 = $('.js-product-hide-until-step-7');
const $itemToFix = $('.js-fixing-view');
const $body = $('body');

const flow2 = $('.js-flow-2');
const flow3 = $('.js-flow-3');

const $flow2Fields = $('.flow-2 .js-attribute-field');
const $flow3Fields = $('.flow-3 .js-attribute-field');

const $submitBtn = $('.js-form-btn');
const $fixedVideo = $('.js-fixed-video');

let state = 1;



function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

deleteCookie("cart")
/**
 * Toggle Fields
 *
 * @return {Void}
 */
function toggleFields($arrayOfFields, enable) {
  $arrayOfFields.each(function() {
    const $this = $(this);

    if (enable) {
      $this.attr('name', $this.data('initial-name'));
      $this.attr("disabled", false);
      return;
    }

    $this.attr('name', $this.attr('name').replace('attributes', ''));
    $this.attr("disabled", true);
  })
}

/**
 * Fix Viewport
 *
 * @return {Void}
 */
function fixingViewPort(action) {
  if ($('#shopify-section-product-template').length) {
    if (action == 'activate') {
      $itemToFix.addClass('fixed');
      $body.removeClass('background-gradient');
    }

    if (action == 'disable') {
      $itemToFix.removeClass('fixed');
      $body.addClass('background-gradient');
    }
  }
}

/**
 * Render Submit Button
 *
 * @return {Void}
 */
function renderSubmitButton(action) {
  if (action == 'show') {
    $submitBtn.show();
    $elementsToHideUntilStep7.show();
    fixingViewPort('disable');
  }

  if (action == 'hide') {
    $submitBtn.hide();
    $elementsToHideUntilStep7.hide();
    fixingViewPort('activate');
  }
}

/**
 * Calculate Progress
 *
 * @return {Void}
 */
function calcProgress() {
  const ratio = (state / maxSteps) * 100;
  $progressBar.css('width', ratio + '%');
}

calcProgress();

/**
 * Render Steps
 *
 * @return {Void}
 */
function renderSteps() { 
  $formSections.each(function(index) {
    const $this = $(this);

    if ($this.data('index') == state) {
      $this.addClass('is-active');
    } else {
      $this.removeClass('is-active');
    }
  })
}

renderSubmitButton('hide');

function checkIfStepIsValid(stateNumber) {
  let isError = false;
  $(`.js-form-section[data-index="${stateNumber}"]`).find('textarea[requred="true"], input[requred="true"]');
  console.log();
  const inputs = $(`.js-form-section[data-index="${stateNumber}"]`).find('textarea, input');
  inputs.each(function() {
    const $this = $(this);
    if ($this.attr('required')) {
      if ($this.attr('type') == 'email' && ! ($this.val().includes('@'))) {
        $this.addClass('invalid');
        isError = true
        return;
      }

      if ($this.val() == '') {
        isError = true;
        $this.addClass('invalid');
        return;
      }

      $this.removeClass('invalid');
    }
  })

  return isError;
}

/**
 * Make Step
 *
 * @return {Void}
 */
function makeStep(direction) {
  //Back
  if (direction == 'back') {
    if (state !== 1) {
      state--;
      $nextBtn.removeClass('disabled');
      renderSubmitButton('hide');
      $elementsToHideUntilStep7.hide();

      if (state == 5) {
        if (step5.hasClass('locked')) {
          state--;
        }
      }

      if (state == 6) {
        if (step6.hasClass('locked')) {
          state--;

          if (step5.hasClass('locked')) {
            state--;
          }
        }
      }

      if (state == 1) {
        $backBtn.addClass('disabled');
      }
    } else {
      $nextBtn.addClass('disabled');
    }

    calcProgress();
  }

  //Next
  if (direction == 'next') {
    if (! (maxSteps == state)) {
      if (checkIfStepIsValid(state)) {
        return;
      }

      state++;
      $backBtn.removeClass('disabled');

      if (state == 5) {
        if (step5.hasClass('locked')) {
          state++;
          state++;
        }
      }

      if (state == 6) {
        if (step6.hasClass('locked')) {
          state++;
        }
      }

      if (state == maxSteps) {
        $nextBtn.addClass('disabled');
        getInputs();
        orderReview();
        $formBack.addClass('is-active');
        $formBack2.addClass('is-active');
        $formControls.addClass('is-disabled');
        renderSubmitButton('show');
        $elementsToHideUntilStep7.show();
        $('.js-product-price').text(sessionStorage.getItem('attributes[price]'));
      }
    } else {
      $backBtn.addClass('disabled');
    }
    calcProgress();
  }
  renderSteps();
}

/**
 * Handle Back to Editor Button
 *
 * @return {Void}
 */
$formBack.find('a').on('click', function(event) {
  event.preventDefault();
  $(this).closest('.form-back').removeClass('is-active');
  $formBack2.closest('.form-back').removeClass('is-active');
  makeStep('back');
  $formControls.removeClass('is-disabled');
  renderSubmitButton('hide');
  $fixedVideo.removeClass('disable-vh');
})

$formBack2.find('a').on('click', function(event) {
  event.preventDefault();
  $(this).closest('.form-back').removeClass('is-active');
  $formBack.closest('.form-back').removeClass('is-active');
  makeStep('back');
  $formControls.removeClass('is-disabled');
  renderSubmitButton('hide');
  $fixedVideo.removeClass('disable-vh');
  
})

/**
 * Handle Back Button
 *
 * @return {Void}
 */
$backBtn.on('click', function(event) {
  event.preventDefault();

  makeStep('back');
})

/**
 * Handle Next Button
 *
 * @return {Void}
 */
$nextBtn.on('click', function(event) {
  event.preventDefault();

  makeStep('next');
})

const $gift = $('.js-gift');
const $giftField = $gift.find('input[name="attributes[Is this a gift?]"]');
const $giftOptions = $gift.find('button');




/**
 * Gift Options (Yes/No)
 *
 * @return {Void}
 */
	
// //       sessionStorage.setItem('attributes[gift]', 'No');  //SET DEFAULT TO NO
//       step5.addClass('locked');
//       flow2.removeClass('is-active');
//       flow3.removeClass('is-active');
// 	  toggleFields($flow2Fields, false);
     
$giftOptions.each(function() {
  if (sessionStorage.getItem("attributes[is this a gift?]")) {
    alert()
  	return
  }
  if ($giftField.val() == '') {
    sessionStorage.setItem('attributes[gift]', 'Yes'); 
    step5.removeClass('locked');
    toggleFields($flow2Fields, true);
    toggleFields($flow3Fields, true);
    $giftField.val('Yes');
  } else {
    if ($giftField.val() == 'Yes') {
      console.log("yes")
      sessionStorage.setItem('attributes[gift]', 'Yes'); 
      step5.removeClass('locked');
      toggleFields($flow2Fields, true);
      toggleFields($flow3Fields, true);
      $(this).closest('.js-gift').find('button').each(function() {
        if ($(this).data('value')) {
//           $(this).addClass('active'); //ADJUST HIGHLIGHTING OF INPUT
        } else {
//           $(this).removeClass('active');
        }
      });
    } else if ($giftField.val() == 'No') {
//       sessionStorage.setItem('attributes[gift]', 'No');
      step5.addClass('locked');
      toggleFields($flow2Fields, false);
      toggleFields($flow3Fields, false);
      flow2.removeClass("is-active")

      $(this).closest('.js-gift').find('button').each(function() {
        if ($(this).data('value')) {
          $(this).removeClass('active');
        } else {
          $(this).addClass('active');
        }
      })
    }
  }
  
   if (sessionStorage.getItem("attributes[gift]") == "Yes") {
    	      step5.removeClass('locked');

    }

  $(this).on('click', function() {
    const $this = $(this);

    if (! $this.hasClass('active')) {
      $this.closest('.js-gift').find('button[class="active"]').removeClass('active');
      $this.addClass('active');
    }

    const value = $this.data('value') ? 'Yes' : 'No';
    sessionStorage.setItem('attributes[gift]', value);
    $giftField.val(value);
  
     flow2.removeClass('is-active');
     flow3.removeClass('is-active');

    if ($this.data('value')) {
      step5.removeClass('locked');
      flow2.addClass('is-active');
      toggleFields($flow2Fields, true);
      toggleFields($flow3Fields, true);

    } else {
      step5.addClass('locked');
      step6.addClass('locked');
      sessionStorage.setItem('attributes[schedule-gift]', 'No');
      flow2.removeClass('is-active');
      flow3.removeClass('is-active');
      toggleFields($flow2Fields, false);
      toggleFields($flow3Fields, false);
    }
    
   
  })
})

/**
 * Handle Field Counter
 *
 * @return {Void}
 */
$('.js-counter').find('.js-counter-target').on('input', function() {
  $(this).bind('input propertychange', function() {
    var maxLength = $(this).attr('maxlength');
    if ($(this).val().length > maxLength) {
      $(this).val($(this).val().substring(0, maxLength));
    }
  })

  $(this).closest('.js-counter').find('.js-count-result').text($(this).val().length);
})


/**
 * Get Initial Landscape
 *
 * @return {Void}
 */
// sessionStorage.setItem('attributes[Landscape]', $('.cart-attribute__field.landscape').find('.active').data('mask-name'));

/**
 * Session Storage
 *
 * @return {Void}
 */
const $fields = $('.cart-attribute__field:not(.landscape)')

function getInputs() {
  $fields.each(function() {
    const $this = $(this);

    $this.find('input').each(function() {
      let value = $(this).val();
      

      if (! $(this).val().length) {
        value = 'None';
      }
      const idOfField = $(this).attr('id');

      if (idOfField == 'message-2' || idOfField == 'message-3' || idOfField == 'message-4') {
        return;
      }

      if (idOfField == "night" || idOfField == "certain-time") { //10-19-21
        return
      }
      
      if (idOfField == "schedule" && value == "Yes") {
//       	flow3.addClass("is-active")
      }
      
       if (idOfField == "a-gift" && value == "Yes") {
      	flow3.addClass("is-active")
      }
      
      if(sessionStorage.getItem("attributes[Video Type]") == "Entire Night") {
        if (idOfField == "time") {
          sessionStorage.removeItem("attributes[Time]")
          $this.remove()
        	return
        }
      
      }
      
      if(idOfField == "schedule" && value != "Yes") {
      	      	flow3.removeClass("is-active")

      }
      
      if (idOfField == "show-date-city") {
      	$(this).prop("checked", true);
      }

      
      if (sessionStorage.getItem("attributes[Schedule send this gift?]") == "No") {
          document.querySelector("#schedule-time-date").remove()
          document.querySelector("#schedule-time-zone").remove()
          document.querySelector("#schedule-date").remove()
                  	
      }

 
      
      if (idOfField == "mm-dd-yyyy" || idOfField == "dd-mm-yyyy") {
        return
      }
      
      if (idOfField == 'message-1') {
        const messageValue1 = $('#message-1').val();
        const messageValue2 = $('#message-2').val();
        const messageValue3 = $('#message-3').val();
        const messageValue4 = $('#message-4').val();

        let value = messageValue1 + '\n' + messageValue2 + '\n' + messageValue3 + '\n' + messageValue4;

        if (!(messageValue1) && !(messageValue2) && !(messageValue3) && !(messageValue4)) {
          value = 'None';
        }

        $('.js-gather-message').val(value);
        sessionStorage.setItem('attributes[Message]', value.replace(/\n/g, '<br />'));
        return
      }
      
//       if (idOfField == "landscape") {
//     	sessionStorage.setItem($(this).attr("name"), value.replace(/\s/g, ''));
//       }
      
      sessionStorage.setItem($(this).attr("name"), value);
    })

    $this.find('textarea').each(function() {
      let value = $(this).val();

      if (! $(this).val().length) {
        value = 'None';
      }
      
      sessionStorage.setItem($(this).attr("name"), value);
      
  
      
    })
    
    
  })
  
    ///Remove the time form field in review when "Night" attribute is set
   let reviewContainerTime = document.querySelector(".form__review.time")
    if (sessionStorage.getItem("attributes[Video Type]") == "Entire Night") {
         reviewContainerTime.classList.add("remove-field")
      //        reviewContainerTime.remove()
    } else {

       reviewContainerTime.classList.remove("remove-field")   

    }

}

/**
 * Gift Checkbox Bonding
 *
 * @return {Void}
 */

if ($('.js-bond-gift').val() == 'Yes') {
  sessionStorage.setItem('attributes[schedule-gift]', 'Yes');
  toggleFields($flow3Fields, true);
  step6.removeClass('locked');
  calcProgress();
  renderSteps();
  flow3.addClass('is-active');
}

$('.js-bond-gift').on('change', function() {
  const value = $(this).prop('checked');
  console.log('I CHNAGED! to: ', value);

  sessionStorage.setItem('attributes[schedule-gift]', value ? 'Yes' : 'No' );

  $('.js-bond-gift').each(function() {
    $(this).prop('checked', value);
    $(this).val(value ? 'Yes' : 'No');
  });

  if ($('.js-form-section.is-active[data-index="5"]').length) {
    value ? step6.removeClass('locked') : step6.addClass('locked');

    if (value) {
      toggleFields($flow3Fields, true)
    } else {
      toggleFields($flow3Fields, false)
    }
  }

  if ($('.js-form-section.is-active[data-index="6"]').length) {
    if (! value) {
      state--;
      step6.addClass('locked');
      toggleFields($flow3Fields, false);
      calcProgress();
      renderSteps();
    }
  }

  if (value) {
    flow3.addClass('is-active');
    toggleFields($flow3Fields, true);
  } else {
    flow3.removeClass('is-active');
    toggleFields($flow3Fields, false);
  }
})


//ADDED 10-19-21///THIS SETS SESSIONSTORAGE FOR [NIGHT OR TIME] BUTTONS

// $('.js-night-time input').on('click', function() {
//   $('.js-night-time input').each(function() {
//     let asdf = document.querySelector("#night")
//     if($(this).prop('checked') == true) {
// 	  sessionStorage.setItem("attributes[Night or Time]", ""+$(this).val()+"" );
//     }

//   })
// })


/**
 * Handle Video Length
 *
 * @return {Void}
 */
const $productVartiants = $('.cart-attribute__field.variants');

$productVartiants.find('button').each(function() {
  const $this = $(this);

  if ($this.hasClass('active')){
    
    if(!sessionStorage.getItem("attributes[video-length]")){
   	 sessionStorage.setItem('attributes[video-length]', $this.data('length'));
     sessionStorage.setItem('attributes[price]', $this.data('price'));

	}

  }

  $this.on('click', function() {
    const $this = $(this);

    const length = $this.data('length');
    sessionStorage.setItem('attributes[video-length]', length);

    const price = $this.data('price');
    sessionStorage.setItem('attributes[price]', price);
  })
})

/**
 * Generate Order Review
 *
 * @return {Void}
 */

function orderReview() {
  $('.form__review').each(function() {
    const $this = $(this);
    const type = $this.data('type');

    if (type !== 'attributes[Message]') {
      const value = sessionStorage.getItem(type);

      $this.find('.form__content').text(value);
      return;
    }
    let message = sessionStorage.getItem(type);

    if (message == '\n\n\n') {
      message = 'None';
    }

    $this.find('.form__content').html(message);
  })
}



///THESE CUSTOMIZATIONS OCCURED 10/11/2021//////


//toggle switch listeners
toggleSwitches()               
                          
                 


                          
function toggleSwitches() {                          
   let button1 = document.querySelector("[data-switch='open-time']")
   let button2 = document.querySelector("[data-switch='close-time']")
   let toggle1 = document.querySelector("[data-toggle='flow-1']") 
   let switch1b = document.querySelector("[data-switch='flow-1b']")
   let toggle1b = document.querySelector("[data-toggle='flow-1b']")
   let switch5 = document.querySelector("[data-switch='flow-5']")
   let toggle5 = document.querySelector("[data-toggle='flow-5']")
   let giftSendToggle = document.querySelector("#schedule")
   let giftButtons = document.querySelectorAll(".gift__actions button")
   let giftInput = document.querySelector("input#a-gift")
   let label = document.querySelector("[data-toggle-label]")
   let locationCanvas = document.querySelector(".canvas-item.city")
   let dateCanvas = document.querySelector(".canvas-item.date")
   let timeCanvas = document.querySelector(".canvas-item.time")
   let noteOnFalse = document.querySelector("[data-toggle-false]")
   let noteOnTrue = document.querySelector("[data-toggle-true]")
   let video1 = document.querySelector("#video1")
   let video2 = document.querySelector("#video2") 
   let vidSource1 = video1.querySelector("source")
   let vidSource2 = video2.querySelector("source")
   let currentVideoUrl1 = vidSource1.getAttribute("src")
   let currentVideoUrl2 = vidSource2.getAttribute("src")
   let videoUrl = "https://cdn.shopify.com/s/files/1/0124/4413/9610/files/My-starry-night-certain-time.m4v?v=1634777536"
   let dateFormatButtons = document.querySelectorAll(".date-format label")

 
   
   dateFormatButtons.forEach( btn => {
     btn.addEventListener("click", (e) => {
     	if (e.target.textContent == "day-month-year" ) {
  			sessionStorage.setItem("attributes[Date Format]","dd-mm-yyyy" )
    	 }  
       else {
       sessionStorage.setItem("attributes[Date Format]","mm-dd-yyyy" )

     	}                       
                            
     })
                                     
   })
   giftButtons.forEach(button => {
     button.addEventListener("click", (e) => {
       console.log(e.target.textContent)
       if (e.target.textContent == "No") {
       	giftInput.value = "No"
        console.log(giftInput)
         sessionStorage.removeItem("attributes[schedule-time]")
        sessionStorage.removeItem("attributes[Schedule send this gift?]")
        sessionStorage.removeItem("attributes[schedule-gift]")
        return
     } 
       
       giftInput.value = "Yes"
       console.log(giftInput.value)

     })
   	 
   })

   
   
//     let form5Inputs = document.querySelectorAll("[data-index='5'] input")
//        console.log(form5Inputs)
//        form5Inputs.forEach(input => {
//        	input.value = ""
//         console.log(input.name)
//         sessionStorage.removeItem(input.name)
//        })
   
   giftSendToggle.addEventListener("click", (e) => {
     if (e.target.value == "No") {
     	e.target.value = "Yes"
        sessionStorage.setItem("attributes[schedule-gift]", "Yes")

        return
     }            
     
     e.target.value = "No"
        sessionStorage.removeItem("attributes[schedule-gift]")
       sessionStorage.removeItem("attributes[Gift Send Date]")
		sessionStorage.removeItem("attributes[schedule-time]")
		sessionStorage.removeItem("send-date")
       sessionStorage.setItem("attributes[Is this a gift?]", "No")

       

                                   
                                   
  })
   
  button1.addEventListener("click", () => {
      button1.checked == true
    button2.checked == false
	toggle1.classList.add("switch-reveal")
       changeVideoOnCertainTime(videoUrl, videoUrl, vidSource1, vidSource2)
       video1.load()
       video2.load()
       sessionStorage.setItem("attributes[Video Type]", "Certain Time")


    
  })
  
  button2.addEventListener("click", () => {
	toggle1.classList.remove("switch-reveal")
      button2.checked == true
  button1.checked == false
   document.querySelector("#canvas-time").innerHTML = ""
         changeVideoOnCertainTime(currentVideoUrl1, currentVideoUrl2, vidSource1, vidSource2)
           video1.load()
           video2.load()
     sessionStorage.setItem("attributes[Video Type]", "Entire Night")
     sessionStorage.removeItem("attributes[Time]")




  })
  
  switch1b.addEventListener("click", (e) => {
    processClickFlex(e, toggle1b)
	toggle1b.querySelector("input").checked = "true" //make sure this defaults to mm-dd-yy
      if (toggle1b.classList.value.indexOf("switch-reveal") > -1) {
    	switch1b.querySelector("input").value = "Yes"
        locationCanvas.style.display = "block"
        dateCanvas.style.display = "block"
       timeCanvas.style.display = "block"

    	return
    }     
    	switch1b.querySelector("input").value = "No"
        locationCanvas.style.display = "none"
        timeCanvas.style.display = "none"
        dateCanvas.style.display = "none"
  })
  
  switch5.addEventListener("click", (e) => {
      	if(e.target.tagName == "INPUT") {
  			processClick(e, toggle5)
            if (toggle5.classList.value.indexOf("switch-reveal") > -1) {
            	noteOnTrue.style.display = "block"
            	noteOnFalse.style.display = "none"
            } else {
           		 noteOnTrue.style.display = "none"
            	noteOnFalse.style.display = "block"
            
            }
        }
  })
  
  function processClick(e, elm) {
        if(elm.classList.value.indexOf("switch-reveal") > -1) {
  				elm.classList.remove("switch-reveal")
                return
        }  
  	  	  elm.classList.add("switch-reveal")
  }
  
  function processClickFlex(e, elm) {
  	if(e.target.tagName == "INPUT") {
        
        if(elm.classList.value.indexOf("switch-reveal-flex") > -1) {
  			elm.classList.remove("switch-reveal-flex")
            label.style.display = "none"
            return
        } else {   
  	  		elm.classList.add("switch-reveal-flex")
            label.style.display = "block"

        }
    }
  }


function changeVideoOnCertainTime(url1, url2, videoOne, videoTwo) {
  videoOne.setAttribute("src", url1)
  videoTwo.setAttribute("src", url2)
	
  }
}

insertTextFromSessionStorage()


function insertTextFromSessionStorage() {
 
  let collectSessionStorageItem = (name, input) => {
    
    
    if (sessionStorage.getItem(""+name+"")) {
      if (sessionStorage.getItem(""+name+"") == "None") { //make sure "none" does not get injected into inputs
      	input.value = ""
        return
      }

      let cacheValue = sessionStorage.getItem(""+name+"")
      	input.value = cacheValue

    }

       console.log(name, input, sessionStorage.getItem(""+name+""))
    
//     if(input.name.indexOf("Recipient") > -1) {
//        console.log(input)
//        alert()
//     }
  
 
  }

  let collectInputNames = () => { //collect all inputs on page
    let elms = document.querySelectorAll(".cart-attribute__field")
    
    elms.forEach(elm => {
      if(elm.querySelector("input")) { //handle all input elms
        let _input = elm.querySelector("input")
          if (elm.querySelector("input").name) {

            let _name = elm.querySelector("input").name
            collectSessionStorageItem(_name, _input)
        }
      }
    
    })
	
  }
  
  
    collectInputNames() 
	setButtonsFromCache()
    setMessagesFromCache()
    setGiftInformationFromCache()
    setScheduleGiftTime()
    setLocationOnCanvas()
    setProduct()
    setVideoLength()
    setIfGift()

    ///CORRECTION FOR WEIRD ERROR (ENTIRE NIGHT INPUT VALUE GETS SET TO CERTAIN TIME)
	document.querySelector("#night").value = "Entire Night"		


    
}




function setButtonsFromCache() {

  
   if(sessionStorage.getItem("attributes[Date Format]") == "mm-dd-yyyy") {
    	let cacheValue = sessionStorage.getItem("attributes[Date Format]")
        let mminput = document.querySelector("#mm-dd-yyyy")
        let ddInput = document.querySelector("#dd-mm-yyyy")


        mminput.checked = true
        mminput.value = "mm-dd-yyyy"
        ddInput.checked = false
        updateCanvasWithDateFormat("mm-dd-yyyy")

      } else if (sessionStorage.getItem("attributes[Date Format]") == "dd-mm-yyyy") {
          let mmInput = document.querySelector("#mm-dd-yyyy")

          let ddInput = document.querySelector("#dd-mm-yyyy")
          mmInput.checked = false
          mmInput.value = "mm-dd-yyyy"
          ddInput.checked = true
          updateCanvasWithDateFormat("dd-mm-yyyy")


      
      } else {
        let mminput = document.querySelector("#mm-dd-yyyy")
        let ddInput = document.querySelector("#dd-mm-yyyy")


        mminput.checked = true
        mminput.value = "mm-dd-yyyy"
        ddInput.checked = false
        updateCanvasWithDateFormat("mm-dd-yyyy")
        
      }
  
  function updateCanvasWithDateFormat(format) {
    
   
  	let dateValue = sessionStorage.getItem("attributes[Date]")
    let dateFormat = sessionStorage.getItem("attributes[Date Format]")
    let dateInput = document.querySelector("#canvas-date")
    const dateSelectors = form.querySelectorAll('select[id^=date-]')
    if(dateValue) {    
//      timeInput.value = timeSelectors[0].value + ':' + timeSelectors[1].value + ' ' + timeSelectors[2].value;
   	 let splitDate = dateValue.split("-")
          if (format == "mm-dd-yyyy") {
     dateSelectors[0].value = splitDate[0]
     dateSelectors[1].value = splitDate[1]
     dateSelectors[2].value = splitDate[2]
     
     dateInput.innerHTML = dateSelectors[0].value + '-' +dateSelectors[1].value + '-' + dateSelectors[2].value;

         } else  {
         
     dateSelectors[0].value = splitDate[1]
     dateSelectors[1].value = splitDate[0]
     dateSelectors[2].value = splitDate[2]
     console.log(dateSelectors[1], splitDate[0])
     dateInput.innerHTML = dateSelectors[1].value + '-' +dateSelectors[0].value + '-' + dateSelectors[2].value;

         
         }

    }
                                           
  }
  
  
      	updateCanvasWithTime()
    
  
  
  function updateCanvasWithTime() {
    let timeValue = sessionStorage.getItem("attributes[Time]")

    if(sessionStorage.getItem("attributes[Video Type]") == "Certain Time" && timeValue) {
      document.querySelector("[data-switch='open-time']").click()
       const timeSelectors = form.querySelectorAll('select[id^=time-]')
       const timeInput = document.querySelector("#canvas-time")
	   const chooseTime = document.querySelector("[data-toggle='flow-1']")
       let nightButton = document.querySelector("#night")
       let timeSelectInput = document.querySelector("#time")
       let timeButton = document.querySelector("#certain-time")
	let splitTimeValue = timeValue.split(" ")
       
        let am_pm = splitTimeValue[1]
        
        let minSecSplit = splitTimeValue[0].split(":")
        let min = minSecSplit[0]
        let sec = minSecSplit[1]
        console.log(min,sec,am_pm)
        
        timeSelectors[0].value = min
        timeSelectors[1].value = sec
        timeSelectors[2].value = am_pm
        
        timeSelectInput.value = timeValue
        
        timeInput.innerHTML = timeSelectors[0].value + ':' +timeSelectors[1].value + ' ' + timeSelectors[2].value;
    	chooseTime.classList.add("switch-reveal")
        
        timeButton.checked = true
        nightButton.checked = false
        return
    	}
    	document.querySelector("label[for='night']").click() /////ADDED THIS
    }
  
  if (sessionStorage.getItem("attributes[Show date and location]")){
    if (sessionStorage.getItem("attributes[Show date and location]") == "No") {
  		let _switch = document.querySelector("#show-date-city")
        let input = document.querySelector("#mm-dd-yyyy")
        let ddInput = document.querySelector("#dd-mm-yyyy")
        let elm = document.querySelector("[data-date-format]")
        let label = document.querySelector("[data-toggle-label]")
        let locationCanvas = document.querySelector("#canvas-location")
        let timeCanvas = document.querySelector("#canvas-time")
        let dateCanvas = document.querySelector("#canvas-date")
        
        timeCanvas.innerHTML = ""
        dateCanvas.innerHTML = ""
        locationCanvas.innerHTML = ""
        
        input.checked = true
        label.style.display = "none"
        elm.classList.remove("switch-reveal-flex")
        ddInput.checked = false
        _switch.checked = false
    }
  }
  
  
  if(sessionStorage.getItem("attributes[schedule-gift]") == "Yes") {
        let buttons = document.querySelectorAll(".js-gift button")
        let button1 = buttons[0]
        let button2 = buttons[1]

        button1.classList.add("active")
        button2.classList.remove("active")
        button1.click()
        
        let giftInput = document.querySelector("input#a-gift")
        giftInput.value = "Yes"


      } else {
        let buttons = document.querySelectorAll(".js-gift button")
        let button1 = buttons[0]
        let button2 = buttons[1]

        button1.classList.remove("active")
        button2.classList.add("active")
        button2.click()
        
        let giftInput = document.querySelector("input#a-gift")
        giftInput.value = "No"
      
      }
  



  }


function setMessagesFromCache() {
  
  if (sessionStorage.getItem("attributes[Message]")){
    let title = document.querySelector("#title").value
    let canvasTitle = document.querySelector("#canvas-title")
    canvasTitle.innerHTML = title
    
    let inputs = document.querySelectorAll("input[data-message]")
    console.log(inputs)
    let messageCache = sessionStorage.getItem("attributes[Message]")
    
    let splitMessageCache = messageCache.split("<br />")
    setClickListenersToInputs()
    splitMessageCache.forEach((item, index) => {
    	inputs[index].value = item
    
    })
  }
  
  function setClickListenersToInputs() {
  	let messageInputs = document.querySelectorAll("[data-message]")
    messageInputs.forEach(input => {
      input.addEventListener("click", () => {

                     updateCanvas(messageInputs) 	       
   	 })
     
    })
    
  }
  
  function updateCanvas(inputs) {
  
  inputs.forEach(input => {
  	   if (input.value) {
      	document.querySelector("#canvas-"+input.id+"").innerHTML = input.value
      
      }
  })
   
  }
}


function setGiftInformationFromCache() {
  
  let sender = sessionStorage.getItem("attributes[Sender Name]")
  let recipient = sessionStorage.getItem("attributes[Recipient Email]")
  let message = sessionStorage.getItem("attributes[Gift Message]")
  
  let senderInput = document.querySelector("#sender-name")
  let recipientInput = document.querySelector("#email")
  let messageInput = document.querySelector("#optional-message")
  
  

  if(sender) {
  	senderInput.value = sender
  }
  
  if(recipient) {
  	recipientInput.value = recipient
  }
  
  if(message) {
  	messageInput.value = message
  }

}

function setScheduleGiftTime() {
  
  sessionStorage.removeItem("[Gift Send Date]")
    let giftButtons = document.querySelectorAll(".gift__actions button")
  	let giftSendDate = sessionStorage.getItem("attributes[Gift Send Date]")
    let gift = sessionStorage.getItem("attributes[gift]")
    let scheduleGift = sessionStorage.getItem("attributes[Schedule send this gift?]")
    let scheduleTime = sessionStorage.getItem("attributes[schedule-time]")
    
    let scheduleSwitch = document.querySelector("#schedule")
    let scheduleElm = document.querySelector("[data-toggle='flow-5']")
    
    let giftTimeOptions = document.querySelector("#schedule-time-date")
    let timeZoneOptions = document.querySelector("#schedule-time-zone")
    
//   if (gift) {
//     giftButtons.forEach(button=> {
//       button.classList.remove("active")
//       console.log(button.textContent, gift)
//       if(button.textContent == gift) {
//       	button.classList.add("active")
//       }
//     })
//   }
  
    if (scheduleGift == "Yes") {
  		scheduleSwitch.checked = true
  		scheduleSwitch.value = "Yes"
        scheduleElm.classList.add("switch-reveal")
        timeZoneOptions.click()
    }
  
  if(scheduleTime) {
    let splitted = scheduleTime.split("-")
    let time = splitted[0].replace(/\s+$/, '')
    let timeZone = splitted[1].replace(/^\s+/g, '');
    
    console.log(splitted, time, timeZone)
    	giftTimeOptions.value = time
        timeZoneOptions.value = timeZone
    
//     giftTimeOptions.forEach(opt => {
//       if (opt.value == time) {
//       	opt.setAttribute("selected", "selected")
//       }
//     })
  
//    timeZoneOptions.forEach(opt => {
//            console.log(opt.value, timeZone)

//       if (opt.value == timeZone) {
//       	opt.setAttribute("selected", "selected")
//       }
//     })
      
    
  }
  
  if(giftSendDate) {
  	let splitted = giftSendDate.split("-")
    let monthSelect = document.querySelector("#schedule-date-month")
    let daySelect = document.querySelector("#schedule-date-day")
    let yearSelect = document.querySelector("#schedule-date-year")
    let skedgeDateInput = document.querySelector("#schedule-date")
    sessionStorage.setItem("send-date", sessionStorage.getItem("attributes[Gift Send Date]"))
  
    console.log(splitted)
       
    daySelect.value = splitted[2] ////date not saved in consistent format
    monthSelect.value = splitted[1]
    yearSelect.value = splitted[0]
    
     let scheduleTime = '';
    scheduleTime = scheduleTimeDate.value + ' - ' + scheduleTimeZone.value;
    sessionStorage.setItem('attributes[schedule-time]', scheduleTime);
    
    skedgeDateInput.value = ""+splitted[0]+"-"+splitted[1]+"-"+splitted[2]+""
 
//         daySelect.options[parseInt(splitted[2]) - 1].selected = "selected" ////date not saved in consistent format


  }

}

function setLocationOnCanvas() {
  let locationCanvas = document.querySelector("#canvas-location")
  if(sessionStorage.getItem("attributes[Location]")) {
  	locationCanvas.innerHTML = sessionStorage.getItem("attributes[Location]") 
  }
    if(sessionStorage.getItem("attributes[Show date and location]") ==  "No") {

          locationCanvas.innerHTML = ""
    }

}

function setProduct() {
  let images = document.querySelectorAll(".landscape-images li")
  let inputs = document.querySelectorAll(".landscape-inputs input")
  let masks = document.querySelectorAll("[data-mask-name]")

  if(sessionStorage.getItem("attributes[Landscape]")) {
    
    images.forEach(image => {
      let name = image.getAttribute("data-mask-name")

      if(image.className.indexOf("active") > -1) {
      	image.classList.remove("active")
      	}
      if (name == sessionStorage.getItem("attributes[Landscape]").replace(/\s/g, '')) {
        image.classList.add("active")
      }
    })
    
    inputs.forEach(input => {
    	input.checked = false
        
        if(input.value == sessionStorage.getItem("attributes[Landscape]")) {
        
        	input.checked = true
        }
    	
    
    })
    
    masks.forEach(mask => {
    	mask.classList.remove("active")
        if (mask.getAttribute("data-mask-name") == sessionStorage.getItem("attributes[Landscape]").replace(/\s/g, '')) {
        	mask.classList.add("active")
        }
    
    })
 
  }
  
  else {
  	images[0].click()
  }
}

function setVideoLength() {
  if (sessionStorage.getItem("attributes[video-length]")) {
      let length = sessionStorage.getItem("attributes[video-length]")
      let selectIndex;
      let variants = document.querySelectorAll(".variants-wrapper button")
      variants.forEach((variant, index) => {
        	variant.classList.remove("active")
        if (variant.getAttribute("data-length") == length) {
        	variant.classList.add("active")
            selectIndex = index
        }
        
   
      
      })
      
      let options =  document.querySelectorAll("#ProductSelect option")
      options.forEach(option => {
      	option.selected = false
      })
     let option = document.querySelector("#ProductSelect").options[selectIndex]
     console.error(option, selectIndex)
     option.selected = true

        
  }


}

function setIfGift() {
  if(sessionStorage.getItem("attributes[Is this a gift?]") == "Yes") {
      let buttons = document.querySelectorAll(".gift-wrapper button")
      buttons.forEach(button => {
      	button.classList.remove("active")
        if(button.textContent == 'Yes') {
        	button.classList.add("active")
            button.click()
        }
      })
    }

}
